import { render, staticRenderFns } from "./UserManager.vue?vue&type=template&id=84993f40&scoped=true&"
import script from "./UserManager.vue?vue&type=script&lang=js&"
export * from "./UserManager.vue?vue&type=script&lang=js&"
import style0 from "./UserManager.vue?vue&type=style&index=0&id=84993f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84993f40",
  null
  
)

export default component.exports